import React from "react";
import "./HotelBookingHistoryDetail.scss";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CameraOutdoorIcon from "@mui/icons-material/CameraOutdoor";
import PersonIcon from "@mui/icons-material/Person";
import ChildCareIcon from "@mui/icons-material/ChildCare";
import { formatDate } from "../../../constants/helper";

const HotelInfoCard = ({ data }: any) => {
  console.log("HotelInfoCard data:", JSON.stringify(data));
  return (
    <div className="card border-0 hotel-info-card">
      <div className="card-body p-3">
        <div className="row">
          <div className="col-lg-5">
            <h4 className="hotel-name">{data?.name}</h4>
            <p className="hotel-address">{data?.address_detail?.address}</p>
            <img src={data?.TripAdvisor?.Rating_Image_Url} alt="Hotel" />
          </div>

          <div className="col-lg-7 mt-2">
            <h2 className=" text-success fw-bold fs-5 ms-3">
              Your Booking is Confirmed!
            </h2>
            {/* <small className="text-muted">
              Thank you for booking with Tripmakers. You will soon receive a
              confirmation via email.
            </small> */}
          </div>
        </div>
        <div className="row g-0">
          <div className="col-md-5">
            <img
              src="https://images.unsplash.com/photo-1566665797739-1674de7a421a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2074&q=80"
              alt="Hotel"
              className="hotel-image"
            />
          </div>

          <div className="col-md-7 px-3">
            {/* <p className="description-text">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy
              text.Lorem Ipsum has been the industry's standard dummy text.Lorem
              Ipsum has been the industry's standard dummy text.Lorem Ipsum has
              been the industry's standard dummy text.
            </p> */}
            <div className="row mt-4">
              <div className=" check-in-card">
                <div className="check-section">
                  <div className="check-label">Check-in</div>
                  <div className="check-date">{data?.check_in_date}</div>
                </div>
                <div className="middle-icon">
                  <AccessTimeIcon />
                </div>
                <div className="check-section">
                  <div className="check-label">Check-out</div>
                  <div className="check-date">{data?.check_out_date}</div>
                </div>
              </div>
            </div>
            <div className="stay-info">
              <div className="stay-detail">
                <CameraOutdoorIcon />
                <span className="stay-text">4 NIGHTS</span>
              </div>
              <div className="stay-detail">
                <PersonIcon />
                <span className="stay-text">
                  {data?.rooms?.[0]?.adult_details?.length} ADULTS
                </span>
              </div>
              <div className="stay-detail">
                <ChildCareIcon />
                <span className="stay-text">
                  {" "}
                  {data?.rooms?.[0]?.child_details?.length} CHILDREN
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="info-container">
          <h6 className="section-title">Owner Information</h6>

          {/* <div className="col border py-2">
              <p className="info-label fw-bold">Booking Time</p>
              <p className="info-value info-dash">12:27:12 PM</p>
            </div> */}
          {/* <div className="col border py-2">
              <p className="info-label fw-bold">Name</p>
              <p className="info-value info-dash">
                {data?.reservation_info?.first_name +
                  " " +
                  data?.reservation_info?.last_name}
              </p>
            </div> */}

          <div className="px-3 passenger-info">
            <table className="table table-bordered align-middle text-center">
              <thead className="table-light">
                <tr>
                  <th>Booking on</th>
                  <th>Booked on</th>
                  <th>E-mail</th>
                  <th>Phone</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="sort">{data?.check_in_date}</div>
                  </td>
                  <td>
                    <div className="sort">
                      {formatDate(data?.reservation_info?.created_at)}
                    </div>
                  </td>
                  <td>
                    <div className="sort">
                      {data?.response?.hotel_email_address}
                    </div>
                  </td>
                  <td>
                    <div className="sort">
                      {data?.response?.hotel_phone_number}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelInfoCard;
